/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/ArticleTeaser/Default/theme';

export const ArticleTeaserDefaultTheme = theme;
